export default __webpack_public_path__ + "images/297dac41973a290293a8ee116e98294e-bluegrass.webp";